<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" lg="5">
        <v-card class="mt-5">
          <v-card-text>

            <v-alert density="comfortable" variant="tonal" color="error" class="mb-5" v-if="isExpired">
              ログインの有効期間が経過しました
            </v-alert>

            <v-alert density="comfortable" variant="tonal" color="error" class="mb-5" v-else v-bind:class="{ 'v-hidden': !isInvalid }">
              ユーザーIDまたはパスワードが違います
            </v-alert>

            <v-text-field label="ユーザーID" v-model="userID"></v-text-field>

            <v-text-field label="パスワード" v-model="password" type="password"></v-text-field>

          </v-card-text>

          <v-card-actions>
            <v-btn variant="outlined" color="primary" class="w-100" v-on:click="getAccessToken" :loading="isLoading">
              ログイン
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref } from 'vue';

import { useDisplay } from 'vuetify';

import { signOut, signIn, confirmSignIn, fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';

import config from '@/config.js';

export default {
  name: 'AuthenticationView',
  setup() {

    const { mobile } = useDisplay();

    const isExpired = ref(false);
    if (window.sessionStorage.getItem('access-token-expired') != null) {
      isExpired.value = true;

      window.sessionStorage.removeItem('access-token-expired');
    }

    const isLoading = ref(false);
    const isInvalid = ref(false);

    const userID = ref('');
    const password = ref('');


    const getAccessToken = async () => {

      isExpired.value = false;

      isLoading.value = true;
      isInvalid.value = false;

      await signOut();

      signIn({
        username: userID.value,
        password: password.value
      }).then(async (result) => {

        if (result.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
          // ユーザー作成後、初回ログイン時
          // 仮パスワードをそのまま使用する
          await confirmSignIn({
            challengeResponse: password.value
          });
        }

        const session = await fetchAuthSession();


        window.sessionStorage.setItem('access-token', session.tokens.idToken.toString());
        window.sessionStorage.setItem('user-name', session.tokens.idToken.payload.name);


        const tilesSetting = window.localStorage.getItem('tiles-setting');
        const chartAreasSetting = window.localStorage.getItem('chart-areas-setting');

        if (tilesSetting != null || chartAreasSetting != null) {
          syncPrivilege();
        } else {
          autoImportDisplaySettings();
        }

      }).catch((/* error */) => {
        isLoading.value = false;
        isInvalid.value = true;
      });

    };

    const syncPrivilege = () => {

      axios.get(
        config.API_URL +
        `/users/me`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        // 参照権限がなくなったモジュールのチャンネルの表示設定を削除する

        const tilesSetting = window.localStorage.getItem('tiles-setting');
        if (tilesSetting != null) {
          const tiles = JSON.parse(tilesSetting);

          window.localStorage.setItem('tiles-setting', JSON.stringify(tiles.filter((tile) => {
            return response.data.browsableModules.includes(tile.moduleID);
          })));
        }

        const chartAreasSetting = window.localStorage.getItem('chart-areas-setting');
        if (chartAreasSetting != null) {
          const chartAreas = JSON.parse(chartAreasSetting);

          chartAreas.forEach((chartArea) => {
            chartArea.channels = chartArea.channels.filter((channel) => {
              return response.data.browsableModules.includes(channel.moduleID);
            });
          });

          window.localStorage.setItem('chart-areas-setting', JSON.stringify(chartAreas));
        }

        window.location.reload();

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const autoImportDisplaySettings = () => {

      const promises = [];

      promises.push(
        axios.get(
          config.API_URL +
          `/users/me/display-templates/tiles`,
          { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
        )
      );

      if (!mobile.value) {

        promises.push(
          axios.get(
            config.API_URL +
            `/users/me/display-templates/chart-areas`,
            { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
          )
        );

      }

      Promise.all(
        promises
      ).then((values) => {

        values.forEach((value) => {

          if (value.data.json != null) {
            window.localStorage.setItem(value.data.template + '-setting', value.data.json);
          }

        });

        window.location.reload();

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    return {
      isExpired,

      isLoading,
      isInvalid,

      userID,
      password,

      getAccessToken
    }
  }
}
</script>

